var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title"},[(_vm.icon)?_c(_vm.icon,{tag:"component",staticClass:"icon"}):_vm._e(),_vm._v(_vm._s(_vm.title))],1)}
var staticRenderFns = []

export { render, staticRenderFns }